module.exports = __webpack_public_path__ + "73a128b8568b8cf8d2543e6627c693ad.jpg";